var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleFooter1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 830,
    height: 631,
    viewBox: "0 0 830 631",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.542 58.6653L654.506 198.323L652.541 474.235L412.612 610.489L174.648 470.831L176.613 194.92L416.542 58.6653Z",
    stroke: "#FFE713",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M431.116 56.841L663.373 210.033L646.833 487.769L398.037 612.313L165.78 459.122L182.32 181.385L431.116 56.841Z",
    stroke: "#FFBD13",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M387.409 57.0981L641.297 172.309L668.464 449.788L441.745 612.056L187.857 496.844L160.689 219.365L387.409 57.0981Z",
    stroke: "#FF7F38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M397.182 57.4716L645.86 180.96L663.255 458.065L431.972 611.683L183.294 488.194L165.899 211.089L397.182 57.4716Z",
    stroke: "url(#paint0_linear_79_255)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_255",
    x1: 274.573,
    y1: 138.134,
    x2: 519.736,
    y2: 552.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8139"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleFooter1);
export default __webpack_public_path__ + "static/media/circle-footer-1.0ca83b169a691789127672de2e6f7c42.svg";
export { ForwardRef as ReactComponent };